import { render } from "./CollectionsContainer.vue?vue&type=template&id=13c5eb83"
import script from "./CollectionsContainer.vue?vue&type=script&lang=js"
export * from "./CollectionsContainer.vue?vue&type=script&lang=js"
script.render = render

export default script